import type { Database } from "../../../__definitions__/database-definitions";
import type { ISO8601 } from "../../../utils/iso8601";
import type { UUID } from "../../../utils/uuid";

export type Segment = {
  id: UUID;
  name: string | null;
  description: string | null;
  is_recipient_type: boolean;
  is_default: boolean | null;
  operation: "AND" | "OR";
  created_at: ISO8601 | null;
  deleted_at: ISO8601 | null;
  recipient_type_key: string | null;
  unsaved?: boolean;
  segment_json: Database["public"]["Tables"]["segment"]["Row"]["segment_json"];
};

export const makeDefaultSegment = (id: UUID): Segment & { name: string } => ({
  id,
  name: "",
  operation: "AND" as const,
  description: "",
  is_recipient_type: false,
  is_default: false,
  created_at: null,
  deleted_at: null,
  recipient_type_key: null,
  segment_json: {
    type: "segment",
    operation: "OR",
    segments: [],
  },
});
